import React from 'react';
import Seo from './Seo';
import './CasePage.css';

const CasePage: React.FC = () => {
    return (
        <div className="case-page">
            <Seo
                title="成功案例｜妙视力视觉训练"
                description="妙视力视觉训练成功案例展示。"
                canonical="https://miaoshili.com/case/"
            />
            <div className="case-page-bg">
                {/* Main Content */}
                <main className="case-main">
                    <h1 className="sr-only">妙视力成功案例</h1>
                    <div className="case-banner">
                        <img src="/case/case_page_title.webp" alt="妙视力成功案例" width={300}/>
                    </div>

                    {/* Case 1 */}
                    <div className="case-section">
                        <img src="/case/case_1.webp" alt="妙视力成功案例1" width={"100%"}/>
                    </div>

                    {/* Case 2 */}
                    <div className="case-section">
                        <img src="/case/case_2.webp" alt="妙视力成功案例2" width={"100%"}/>
                    </div>

                    {/* Case 3 */}
                    <div className="case-section">
                        <img src="/case/case_3.webp" alt="妙视力成功案例3" width={"100%"}/>
                    </div>

                    {/* Case 4 */}
                    <div className="case-section">
                        <img src="/case/case_4.webp" alt="妙视力成功案例4" width={"100%"}/>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default CasePage;